/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Recentpricedrops2Inputs */

const he_home_recentpricedrops2 = /** @type {(inputs: Home_Recentpricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ירידות מחירים אחרונות`)
};

const en_home_recentpricedrops2 = /** @type {(inputs: Home_Recentpricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent Price Drops`)
};

/**
* | output |
* | --- |
* | "Recent Price Drops" |
*
* @param {Home_Recentpricedrops2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const home_recentpricedrops2 = /** @type {((inputs?: Home_Recentpricedrops2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Recentpricedrops2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_recentpricedrops2(inputs)
	return en_home_recentpricedrops2(inputs)
});
export { home_recentpricedrops2 as "home_recentPriceDrops" }